/**
 * Element.prototype.matches polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#polyfill
 */
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/**
 * NodeList.prototype.forEach() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill
 */
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

/**
 * Array.prototype.forEach polyfill
 * https://gist.github.com/hufyhang/c303ce1b80c7b6f8a73e
 */
if (!Array.prototype.forEach) {
	Array.prototype.forEach = function forEach(callback, thisArg) {
		if (typeof callback !== "function") {
			throw new TypeError(callback + " is not a function");
		}
		var array = this;
		thisArg = thisArg || this;
		for (var i = 0, l = array.length; i !== l; ++i) {
			callback.call(thisArg, array[i], i, array);
		}
	};
}

/**
 * Object.entries polyfill
 * http://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#polyfill
 */
if (!Object.entries) {
	Object.entries = function (obj) {
		var ownProps = Object.keys(obj),
			i = ownProps.length,
			resArray = new Array(i); // preallocate the Array
		while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

		return resArray;
	};
}

/**
 * closest polyfill
 * http://developer.mozilla.org/en-US/docs/Web/API/Element/closest#polyfill
 */
if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;

		do {
			if (Element.prototype.matches.call(el, s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}
